import React from 'react';
import {
  TaskAssigneeType,
  type Task,
  type TaskUpdateBodyParams,
} from 'src/api/generated';
import type { ComponentSize } from '../../../types/component.type';
import {
  AssigneeDropdown,
  type AssigneeValue,
} from '../dropdowns/assignee-dropdown';
import { getAssigneeTypeEnum } from '../../../utils/tasks/assignee.util';

/**
 * Interface for the TaskAssigneeDropdown component props
 */
interface TaskAssigneeDropdownProps {
  task: Task;
  onAssigneeChange: (
    taskId: string,
    assignedTo: NonNullable<TaskUpdateBodyParams['assignedTo']>
  ) => Promise<void>;
  disabled?: boolean;
  isFinished?: boolean;
  size?: ComponentSize;
  className?: string;
}

/**
 * Task-specific wrapper for the generic AssigneeDropdown component
 */
export const TaskAssigneeDropdown: React.FC<TaskAssigneeDropdownProps> = ({
  task,
  onAssigneeChange,
  disabled = false,
  isFinished = false,
  size = '2xs',
  className = '',
}) => {
  const currentValue: AssigneeValue | undefined = task.assignedTo.id
    ? {
        type:
          task.assignedTo.type === TaskAssigneeType.USER
            ? 'user'
            : 'ai_employee',
        id: task.assignedTo.id,
      }
    : undefined;

  const handleAssigneeChange = async (assignee: AssigneeValue) => {
    if (!task.id) return;
    const assignedToType = getAssigneeTypeEnum(assignee.type);

    await onAssigneeChange(task.id, {
      type: assignedToType,
      id: assignee.id,
    });
  };

  return (
    <AssigneeDropdown
      value={currentValue}
      onAssigneeChange={handleAssigneeChange}
      disabled={disabled}
      size={size}
      className={`${className} ${isFinished ? 'opacity-60' : ''}`}
      placeholder="Sin asignar"
    />
  );
};
